export default __webpack_public_path__ + "static/media/view.6b46d34b.svg";